import { Components, Theme } from '@mui/material';

export const getMuiIconButton = (
  theme: Theme,
): Components['MuiIconButton'] => ({
  styleOverrides: {
    root: {
      variants: [
        /** Matches `Button variant="contained" color="error"` (destructive actions). */
        {
          props: { color: 'error' },
          style: {
            borderRadius: Number(theme.shape.borderRadius) * 2,
            color: 'var(--mui-palette-button-error-main)',
            backgroundColor: 'var(--mui-palette-button-error-dark)',
            '&:hover': {
              backgroundColor: 'var(--mui-palette-button-error-light)',
            },
            '& .MuiSvgIcon-root': {
              color: 'inherit',
            },
          },
        },
      ],
    },
  },
});
